module.exports = __webpack_public_path__ + "static/media/12(1).c2c48548.jpg";